<template>
  <div class="userlist-wrapper">
    <ul class="userlist" v-if="resetElem">
      <li 
        v-for="(item,index) in hxChatList" 
        :key="index" 
        @click="select2(item, getKey(item))"
        :class="['item',{'on':getKey(item) == chatId }, type ? 'custom-icon': '']" 
      >   
        <img v-if="type !=='group'"  :src="item.PhotoUrl || 'http://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/bpofolder/20200828/202008281453585550.png?x-oss-process=style/bpostyle'" alt="">
        <img v-else  src="https://tse4-mm.cn.bing.net/th/id/OIP.ML_VlmLwGryZx_NSh-Kv6wHaHa?w=182&h=180&c=7&o=5&pid=1.7" alt="">
        <div class="custom-title">
          <span class="name">{{type=='group'?resetName(item.name):item.NickName}}</span>
          <span class="unreadNum" v-if="item.unread_num">{{item.unread_num}}</span>
        </div>
        <div class="last-msg-box">
          <div class="last-msg">{{item.lastMsg}}</div>
          <span class="time-style">{{item.msgTime}}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState} from "vuex";
export default {
  data() {
    return {
      activedKey: {
        contact: "",
        group: "",
        chatroom: ""
      },
      showFirendMenus: false,
      firendMenus: [
        {
          name: "加入黑名单",
          id: "1",
          icon: "add-o"
        },
        {
          name: "删除好友",
          id: "2",
          icon: "delete"
        }
      ],
      message: "",
      isHttps: window.location.protocol === "https:",
      loadText: "加载更多",
      status: {
        sending: "发送中",
        sent: "已发送",
        read: "已读"
      },
      isCollapse: true,
      unRead: "",
      hxChatList:[],//聊天列表
      hxChatList2: [],
      selectedKeys: localStorage.getItem('chatId') || '',
      resetElem: true
    };
  },

  props: [
    "type", // 聊天类型 contact, group, chatroom
    "username", // 选中的聊天对象
    "select"
  ],
  computed: {
    ...mapGetters({
      contact: "onGetContactUserList",
      group: "onGetGroupUserList",
      chatroom: "onGetChatroomUserList",
      msgList: "onGetCurrentChatObjMsg",
      groupInfo:'onGetGroupinfo',
    }),
    ...mapState({
      chatId:state=>state.chatId,
      // historyChatId:state=>state.historyChatId,
    }),
    userList() {
      console.log("this.contact",this.contact);
      return {
        contact: this.contact.filter(item => {
          if (item && !this.blackList.includes(item.name)) {
            return item;
          }
        }),
        group: this.group,
        chatroom: this.chatroom
      };
    },
    blackList() {
      return Object.keys(this.$store.state.friendModule.blackList);
    },
    chatList() {
      console.log("2222222",this.chatId);
      if(!this.chatId) {
        this.$store.commit('setCPageItem',{})
      }else {
        setTimeout(() => {
          console.log("this.hxChatList.length 现在进入的是",this.hxChatList.length);
          if(this.hxChatList.length) {
            let chooseIndex = null;
            for(let theChooseList of ['hxChatList']) {
              this[theChooseList].map((item,index)=>{
                if(this.getKey(item) == this.chatId) {
                  chooseIndex = index;
                  this.select2(this[theChooseList][index], this.getKey(this[theChooseList][index]))
                }
              })
            }
            this.$nextTick(() =>{
              if(chooseIndex === null) {
                this.$store.commit('setCPageItem',{})
              }
            })
            console.log("默认显示列表的第一个人为聊天联系人 chooseIndex",chooseIndex);
          }
        }, 50);
      }
      return this.$store.state.chat.msgList;
    },
    hxIsLogin() {
      return this.$store.state.hxIsLogin;
    },
  },
  watch: {
    contact(newVal, oldVal) {
      console.log("sessiion contact",newVal);
        this.getHxChatList();
    },
    group(newVal, oldVal) {
      this.getHxChatList();
        return newVal;
    },
  },
  mounted() {
    // 取到黑名单列表值将黑名单匹配用户列表进行筛选
    let blackList = this.$store.state.friendModule.blackList;
    this.$store.commit("changeUserList", blackList);
    if(this.hxChatList.length==0){
      this.getHxChatList();
      setTimeout(() => {
        this.getHxChatList();
      }, 8000);
    }
  },
  methods: {
    ...mapActions([
      "onGetContactUserList",
      "onGetGroupUserList",
      "onGetChatroomUserList",
      "onGetCurrentChatObjMsg",
      "onSendText",
      "onCallVideo",
      "onCallVoice",
      "getGroupMembers",
      "getHistoryMessage",
      "onAddBlack",
      "onDelteFirend",
      "onGetGroupinfo",
      "recallMessage",
      "onGetGroupBlack",
      "onGetFirendBlack",
      "onSetMessageRead"
    ]),
    //删除名称前缀
    resetName(value){
      let str='';
      if(value){
        let arr=value.split('-');
        if(arr.length > 1) {
          arr.splice(0,1);
          str=arr.join('-');
        }else {
          return value
        }
      }
      return str;
    },
    getKey(item) {
      let key = "";
      switch (this.type) {
        case "contact":
          key = item.name;
          break;
        case "group":
          key = item.groupid;
          break;
        case "chatroom":
          key = item.id;
          break;
        default:
          break;
      }
      return key;
    },
    getUnreadNum(item) {
      let name=this.$store.state.chatType;
      const chatList = this.chatList[name];
      let userId = "";
      if (name == "contact") {
        userId = item.name;
      } else if (name == "group") {
        userId = item.groupid;
      } else {
        userId = item.id;
        return 0;
      }
      const currentMsgs = chatList[userId] || [];
      let unReadNum = 0;
      currentMsgs.forEach(msg => {
        if (msg.status !== "read" && msg.status !== "recall" && !msg.bySelf) {
          unReadNum++;
        }
      });
      return unReadNum;
    },
    select2(key, index) {
      console.log("00000000000 key",key,"index",index);
      key.IsShowChartButton =  false
      this.$store.commit('setChatId',index);
      this.$data.selectedKeys = index;
      this.select(key);
      this.$data.activedKey[this.type] = key;
      
      this.$store.commit('setCPageItem', key)
      this.onSetMessageReadFun(key)
    },
    onSetMessageReadFun(key) {
      this.onSetMessageRead({
        chatId: key,
        chatType: this.$store.state.chatType
      });
      // this.$store.dispatch('getSessionList', '')
    },
    readablizeBytes(value) {
      let s = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
      let e = Math.floor(Math.log(value) / Math.log(1024));
      return (value / Math.pow(1024, Math.floor(e))).toFixed(2) + " " + s[e];
    },

    // TODO 可以抽离到utils
    renderTime(time) {
      let nowStr = new Date();
      let localStr = time ? new Date(time) : nowStr;
      let localMoment ='';
      if(this.$formatTime(localStr,'yyy-MM-dd')==this.$formatTime(nowStr,'yyy-MM-dd')){
        localMoment = this.$formatTime(localStr,'hh:mm');
      }else{
        localMoment = this.$formatTime(localStr,'MM/dd hh:mm');
      }
      return localMoment;
    },
    //获取聊天列表并排序
    getHxChatList(){
      let list=[];
      if(this.type=='group'){
        list=this.group || [];
      }else if(this.type=='contact'){
        list=this.contact || [];
      }
      let arr=[];

      for (let i = 0; i < list.length; i++) {
        let lastMsg=this.getLastMsg(list[i]);
        let obj={
          ...list[i],
          ...lastMsg,
        }
        arr.push(obj);
      }
        arr.sort((a,b)=>{
          return b.timeStamp-a.timeStamp;
        });

        let serviceArr = [];
        if(this.type=='contact') {
          arr.map(item =>{
            if(item.NickName.indexOf('客服') !== -1) {
              serviceArr.push(item)
            }
          })
          this.hxChatList2= serviceArr;

          let newArr2 = [];
          arr.map(item =>{
            if(item.NickName.indexOf('客服') == -1) {
              newArr2.push(item)
            }
          })
          this.hxChatList=newArr2;
        }else {
          this.hxChatList=arr;
        }
        console.log("list ------ 获取左侧人员列表并排序",arr);
        this.$forceUpdate();
    },
    getLastMsg(item) {
      let name= this.type;
      const chatList = this.chatList[name];
      let userId = "";
      if (name == "contact") {
        userId = item.name;
      } else if (name == "group") {
        userId = item.groupid;
      } else {
        userId = item.id;
      }
      const currentMsgs = chatList[userId] || [];
      let lastMsg = "";
      let lastType =currentMsgs.length && currentMsgs[currentMsgs.length - 1].type;
      if (currentMsgs.length) {
        if (lastType === "img") {
          lastMsg = "[image]";
        } else if (lastType === "file") {
          lastMsg = currentMsgs[currentMsgs.length - 1].filename;
        } else if (lastType === "audio") {
          lastMsg = "[audio]";
        } else if (lastType === "vidio") {
          lastMsg = "[vidio]";
        } else if(lastType === 'text' && currentMsgs[currentMsgs.length - 1].ext && currentMsgs[currentMsgs.length - 1].ext.chat_sp_type==10001) {
          lastMsg = "[投标信息]";
        } else if(lastType === 'text' && currentMsgs[currentMsgs.length - 1].ext && currentMsgs[currentMsgs.length - 1].ext.chat_sp_type==10002) {
          lastMsg = "[邀请信息]";
        } else if(lastType === 'text' && currentMsgs[currentMsgs.length - 1].ext && currentMsgs[currentMsgs.length - 1].ext.chat_sp_type==10003) {
          lastMsg = "[咨询信息]";
        } else {
          lastMsg = currentMsgs[currentMsgs.length - 1].msg;
        }
      }
      let timeStamp=0;
      if(currentMsgs.length){
        timeStamp=currentMsgs[currentMsgs.length - 1].time || new Date().getTime();
      }
      let msgTime = currentMsgs.length? this.renderTime(currentMsgs[currentMsgs.length - 1].time): "";
      return {
        lastMsg,
        msgTime,
        timeStamp
      };
    },
    
  }
};
</script>

<style lang='scss'>
.userlist-wrapper{
  height: 100%;
  overflow-y: auto;
  border-right: 1px solid #e8e8e8;
  .list-hd{
    height: 60px;
    padding: 10px 10px;
    border-bottom: 1px solid #e5e5e5;
    background-color: #fff;
    font-size: 16px;
    color: #333;
    line-height: 24px;
    display: flex;
    align-items: center;
  }
  .btn-change{
    cursor: pointer;
    flex:1;
  }
  .icon-back{
    cursor: pointer;
    text-align: center;
    width: 20px;
    color: #999;
  }
}
.userlist {
  padding-left: 0;
  .item{
    list-style: none;
    position: relative;
    padding: 6.5px 10px;
    line-height: 24px;
    border-bottom: 1px solid #e5e5e5;
    cursor: pointer;
    &.on{
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
  .item.custom-icon {
    padding-left: 60px;
    >img{
      position: absolute;
      left: 10px;
      top: 10px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: inline-block;
    }
  }
  
  .custom-title {
    margin-top: 3px;
    margin-bottom: 3px;
    .name{
      display: block;
      font-size: 14px;
      color: #666;
      line-height: 20px;
      font-weight: bold;
    }
  }
  .unreadNum {
    position: absolute;
    left: 42px;
    top: 5px;
  }
  .last-msg-box{
    overflow: hidden;
    position: relative;
    min-height: 20px;
    
  }
  .last-msg{
    float: left;
    max-width: 100px;
    font-size: 12px;
    color: #999;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .time-style{
    float: right;
    font-size: 12px;
    line-height: 20px;
    color: #888c98;
    position: absolute;
    right: 0px;
    top:0;
  }
}
</style>
